import { Mark } from '@tiptap/core';
import '@tiptap/extension-text-style';

export const FontSize = Mark.create({
	name: 'fontSize',

	addOptions() {
		return {
			types: ['textStyle'],
		};
	},

	addGlobalAttributes() {
		return [
			{
				types: this.options.types,
				attributes: {
					fontSize: {
						default: null,
						parseHTML: (element) => element.style.fontSize,
						renderHTML: (attributes) => {
							if (!attributes.fontSize) {
								return {};
							}

							return {
								style: `font-size: ${attributes.fontSize}`,
							};
						},
					},
				},
			},
		];
	},

	addCommands() {
		// prettier-ignore
		return {
			setFontSize: (fontSize) => ({ editor }) => editor.chain().setMark('textStyle', { fontSize }).run(),
			unsetFontSize: () => {
				({ chain }) => chain().setMark('textStyle', { fontSize: null }).removeEmptyTextStyle().run();
			},
		};
	},
});
